var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8C6 7.448 5.552 7 5 7C4.448 7 4 7.448 4 8C4 8.552 4.448 9 5 9C5.552 9 6 8.552 6 8ZM2 8.99063C2 9.54809 2.44463 10 3.00087 10H16.9991C17.5519 10 18 9.55665 18 8.99063V7.00937C18 6.45191 17.5554 6 16.9991 6H3.00087C2.44811 6 2 6.44335 2 7.00937V8.99063ZM0 10.0019C0 11.1054 0.898212 12 1.9908 12H18.0092C19.1087 12 20 11.1133 20 10.0019V5.9981C20 4.89458 19.1018 4 18.0092 4H1.9908C0.891309 4 0 4.88671 0 5.9981V10.0019ZM2 15C2 15.5523 2.44463 16 3.00087 16H16.9991C17.5519 16 18 15.5561 18 15C18 14.4477 17.5554 14 16.9991 14H3.00087C2.44811 14 2 14.4439 2 15ZM2 1C2 1.55228 2.44463 2 3.00087 2H16.9991C17.5519 2 18 1.55614 18 1C18 0.447715 17.5554 0 16.9991 0H3.00087C2.44811 0 2 0.443865 2 1Z",
    fill: "#6C7380"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.099d82bff4a651a63a0999b7a744de2e.svg";
export { ForwardRef as ReactComponent };